<template>
    <div class="col-sm-12 d-flex flex-wrap py-3">

        <extra-selector :reservation="reservation" v-if="reservation.event.product" class="w-100"></extra-selector>

        <div class="text-center fs-large dark w-100" v-else>
            No extras available
        </div>

    </div>
</template>

<script>
import ExtraSelector from '@/components/reservations/NewReservation/Resume/AddExtra/ExtraSelector'

export default {
    data: function() {
        return {

        }
    },
    props:{
        reservation:{
            type: Object
        }
    },
    components: {
        ExtraSelector
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// TabExtras.vue?a642b018